/** Fragmento de URL: código one-time SSO (`#ap_code=...`). */
export const CROSS_APP_CODE_HASH_KEY = 'ap_code';

/** Quita `/login` y barras finales de una base URL. */
export function normalizeAppBaseUrl(rawBaseUrl: string): string {
  return String(rawBaseUrl ?? '')
    .trim()
    .replace(/\/+$/, '')
    .replace(/\/login$/i, '');
}

/**
 * URL de destino sin sesión (solo origen + path).
 * Ej: `http://localhost:4203/app/cashier`
 */
export function buildCrossAppPlainUrl(
  targetBaseUrl: string,
  entryPath: string,
): string {
  const base = normalizeAppBaseUrl(targetBaseUrl);
  const path = entryPath.startsWith('/') ? entryPath : `/${entryPath}`;
  return `${base}${path}`;
}

/**
 * Arma la URL de destino con el código one-time en el hash.
 * Ej: `http://localhost:4203/app/cashier#ap_code=...`
 */
export function buildCrossAppHandoffUrl(
  targetBaseUrl: string,
  entryPath: string,
  code: string | null,
): string {
  const target = buildCrossAppPlainUrl(targetBaseUrl, entryPath);
  if (!code) {
    return target;
  }
  try {
    return `${target}#${CROSS_APP_CODE_HASH_KEY}=${encodeURIComponent(code)}`;
  } catch {
    return target;
  }
}

function clearLocationHash(loc: Location): void {
  try {
    window.history.replaceState(null, '', `${loc.pathname}${loc.search}`);
  } catch {
    // ignore
  }
}

/**
 * Lee y elimina `#ap_code=...` del hash. Devuelve el código o null.
 */
export function readCrossAppCodeFromLocation(
  loc: Location = window.location,
): string | null {
  if (typeof loc === 'undefined') return null;

  const rawHash = (loc.hash ?? '').replace(/^#/, '');
  if (!rawHash) return null;

  const params = new URLSearchParams(rawHash);
  const code = params.get(CROSS_APP_CODE_HASH_KEY);
  if (!code) return null;

  clearLocationHash(loc);
  const trimmed = code.trim();
  return trimmed || null;
}
